import ClubEmployee from '../dto/ClubEmployee';
import Error from '../model/Error';
import axios from 'axios';

export default class InstructorRepository {
    static findAllByClub(clubId, withoutFilter) {
        return new Promise((resolve, reject) => {
            let url = `/club/clubs/${clubId}/offerings/instructors`;
            if (withoutFilter) {
                url = `${url}?showAll=1`;
            }
            axios
                .get(url)
                .then((response) => resolve(response.data.data.map((data) => ClubEmployee.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
